// This file is auto-generated by @hey-api/openapi-ts

import type { CreateClientConfig } from './client.gen'

import { getBrandConfig } from '@/config/config'

export const createClientConfig: CreateClientConfig = (config) => {
  if (!import.meta.env.STORYBOOK && import.meta.env.MODE !== 'test') {
    return {
      ...config,
      baseUrl: getBrandConfig().pamStoreApiUrl,
    }
  }

  return {
    ...config,
    baseUrl: 'https://pam-store-api.vgw.co',
  }
}
